import { defineStore } from "pinia"

import { MixpanelInstance } from "@/plugins/mixpanel/mixpanel"

export const useModalStore = defineStore("modal", () => {
  const trackModal = (params) => {
    MixpanelInstance.track("modal_viewed", params)
  }

  return {
    trackModal,
  }
})
